import proverbs from '../data/proverbs.json'

/**
 * Returns the Proverbs chapter and verses for the given date.
 * Chapter formula: ((dayOfMonth - 1) % 31) + 1 — wraps day 32+ back to chapter 1.
 *
 * @param {Date|{getDate: () => number}} date
 * @returns {{ chapter: number, kjv: string[], web: string[] }}
 */
export function getProverbsChapter(date) {
  const chapter = ((date.getDate() - 1) % 31) + 1
  return {
    chapter,
    kjv: proverbs.kjv[String(chapter)],
    web: proverbs.web[String(chapter)],
  }
}
